@if (data) {
  <div class="recipient-address" fxLayout="row"
    fxLayoutAlign="start center">
    <div><i class="icon {{ data?.channelIcon }}" [title]="data.title"></i></div>
    <div class="text">{{data?.address }}</div>
  </div>
}
